import React, { useState } from "react";
import axios from "axios";
import { Formik, Form, Field, ErrorMessage } from "formik";
import * as Yup from "yup";
import { Fade } from "react-reveal";
import "./formStyle.css";


const formSchema = Yup.object().shape({
  email: Yup.string()
    .email("Invalid email")
    .required("Required"),
  message: Yup.string().required("Required")
});


export default function ContactMeForm() {
  /* Server State Handling */
  const [serverState, setServerState] = useState();
  const handleServerResponse = (ok, msg) => {
    setServerState({ ok, msg });
  };
  const handleOnSubmit = (values, actions) => {
    axios({
      method: "POST",
      url: "http://formspree.io/xgenvkob",
      data: values
    })
      .then(response => {
        actions.setSubmitting(false);
        actions.resetForm();
        handleServerResponse(true, "Thanks , I will get back to you soon!");
      })
      .catch(error => {
        actions.setSubmitting(false);
        //handleServerResponse(false, error.response.data.error);
      });
  };
  return (
    <Fade bottom duration={1000} distance="20px">
      <div className="main">
        <h1 className="prof-title">Leave a small message</h1>
        <div className="row">
          <div className="main-content-profile">
            <div className="blog-header">
              <p className="subTitle blog-subtitle">Don't Hesitate to contact with me ,I generally reply within a day</p>
              <Formik
                initialValues={{ email: "", message: "" }}
                onSubmit={handleOnSubmit}
                validationSchema={formSchema}
              >
                {({ isSubmitting }) => (
                  <Form id="fs-frm" noValidate>
                    <label htmlFor="email">Email:</label>
                    <Field className="input"  id="email" type="email" name="email" />
                    <ErrorMessage name="email" className="errorMsg" component="p" />
                    <label htmlFor="message">Message:</label>
                    <Field id="message" name="message" component="textarea" />
                    <ErrorMessage name="message" className="errorMsg" component="p" />
                    <button class="main-button" type="submit" disabled={isSubmitting}>
                      Submit
                    </button>
                    {serverState && (
                      <p className={!serverState.ok ? "errorMsg" : ""}>
                        {serverState.msg}
                      </p>
                    )}
                  </Form>
                )}
              </Formik>
            </div>
          </div>
        </div>
      </div>
    </Fade>

  );
};